<template>
    <div class="wrapper-form-block-socio-dados-complementares" :inert="pPreview">
        <p><strong>Quais os dados complementares do sócio?</strong></p>
    <br/>
    <div class="columns is-multiline">
      <div class="column is-4"  :class="{'allow-markup-error': markupErrorSexo}">
        <TrfSelect
          class="mb-0"
          :options="data.listagemSexo"
          :noOptionsText="'Sexos não encontrados'"
          label="Sexo"
          idSelect="form-block-socio-sexo"
          @valueSelect="$event => setSexo($event)"
          placeholder="Selecione"
          :required="false"
          ref="BlockSocioSexo"
          :loading-data="data.loading"
          v-e2e="'block-sexo-socio'"
        ></TrfSelect>
        <p class="error-message" v-if="markupErrorSexo">
            Campo obrigatório!
        </p>
      </div>
      <div class="column is-4"  :class="{'allow-markup-error': markupErrorCor}">
        <TrfSelect
          class="mb-0"
          :options="data.listagemCor"
          :noOptionsText="'Cores não encontradas'"
          label="Cor"
          idSelect="form-block-socio-cor"
          @valueSelect="$event => setCor($event)"
          placeholder="Selecione"
          :required="false"
          ref="BlockSocioCor"
          :loading-data="data.loading"
          v-e2e="'block-cor-socio'"
        ></TrfSelect>
        <p class="error-message" v-if="markupErrorCor">
            Campo obrigatório!
        </p>
      </div>
      <div class="column is-4"  :class="{'allow-markup-error': markupErrorEscolaridade}">
        <TrfSelect
          class="mb-0"
          :options="data.listagemEscolaridade"
          :noOptionsText="'Escolaridades não encontradas'"
          label="Escolaridade"
          idSelect="form-block-socio-escolaridade"
          @valueSelect="$event => setEscolaridade($event)"
          placeholder="Selecione"
          :required="false"
          ref="BlockSocioEscolaridade"
          :loading-data="data.loading"
          v-e2e="'block-escolaridade-socio'"
        ></TrfSelect>
        <p class="error-message" v-if="markupErrorEscolaridade">
            Campo obrigatório!
        </p>
      </div>
      <div class="column is-6"  :class="{'allow-markup-error': markupErrorPaisDeNascimento}">
        <TrfSelect
          class="mb-0"
          :options="data.listagemPaises"
          :noOptionsText="'Países não encontrados'"
          label="País de nascimento"
          idSelect="form-block-socio-pais-de-nascimento"
          @valueSelect="$event => setPaisDeNascimento($event)"
          placeholder="Selecione"
          :required="false"
          ref="BlockSocioPaisDeNascimento"
          :loading-data="data.loading"
          v-e2e="'block-paisNascimento-socio'"
        ></TrfSelect>
        <p class="error-message" v-if="markupErrorPaisDeNascimento">
            Campo obrigatório!
        </p>
      </div>
      <div class="column is-6"  :class="{'allow-markup-error': markupErrorNacionalidade}">
        <TrfSelect
          class="mb-0"
          :options="data.listagemPaises"
          :noOptionsText="'Países não encontrados'"
          label="Nacionalidade"
          idSelect="form-block-socio-nacionalidade"
          @valueSelect="$event => setNacionalidade($event)"
          placeholder="Selecione"
          :required="false"
          ref="BlockSocioNacionalidade"
          :loading-data="data.loading"
          v-e2e="'block-nacionalidade-socio'"
        ></TrfSelect>
        <p class="error-message" v-if="markupErrorNacionalidade">
            Campo obrigatório!
        </p>
      </div>
      <div v-if="formData.nacionalidade == 105" class="column is-6"  :class="{'allow-markup-error': markupErrorNaturalidade}">
        <TrfSelect
          class="mb-0"
          :options="data.listagemEstados"
          :noOptionsText="'Países não encontrados'"
          label="Naturalidade"
          idSelect="form-block-socio-naturalidade"
          @valueSelect="$event => setNaturalidade($event)"
          placeholder="Selecione"
          :required="false"
          ref="BlockSocioNaturalidade"
          :loading-data="data.loading"
          v-e2e="'block-naturalidade-socio'"
        ></TrfSelect>
        <p class="error-message" v-if="markupErrorNaturalidade">
            Campo obrigatório!
        </p>
      </div>
      <div v-if="formData.nacionalidade == 105" class="column is-6"  :class="{'allow-markup-error': markupErrorMunicipioDeNascimento}">
        <TrfInput
          class="mb-0"
          label="Município de nascimento"
          placeholder="Município de nascimento"
          margin="0"
          id="form-block-socio-municipio-de-nascimento"
          v-model="formData.municipioDeNascimento"
          maxLength="100"
          ref="BlockSocioMunicipioDeNascimento"
          v-e2e="'block-municipioNascimento-socio'"
          :required="false"
          @update:modelValue="setMunicipioDeNascimento"
        ></TrfInput>
        <p class="error-message" v-if="markupErrorMunicipioDeNascimento">
            Campo obrigatório!
        </p>
      </div>
      <div class="column is-6"  :class="{'allow-markup-error': markupErrorEstadoCivil}">
        <TrfSelect
          class="mb-0"
          :options="data.listagemEstadoCivil"
          :noOptionsText="'Estados cívis não encontrados'"
          label="Estado civil"
          idSelect="form-block-socio-estado-civil"
          @valueSelect="$event => setEstadoCivil($event)"
          placeholder="Selecione"
          :required="false"
          ref="BlockSocioEstadoCivil"
          :loading-data="data.loading"
          v-e2e="'block-estadoCivil-socio'"
        ></TrfSelect>
        <p class="error-message" v-if="markupErrorEstadoCivil">
            Campo obrigatório!
        </p>
      </div>
      <div class="column is-6"  :class="{'allow-markup-error': markupErrorRegimeDoCasamento}">
        <TrfSelect
          class="mb-0"
          :options="data.listagemRegimeCasamento"
          :noOptionsText="'Regimes de casamento não encontrados'"
          label="Regime de casamento"
          idSelect="form-block-socio-regime-casamento"
          @valueSelect="$event => setRegimeDoCasamento($event)"
          placeholder="Selecione"
          :required="false"
          ref="BlockSocioRegimeDoCasamento"
          :loading-data="data.loading"
          v-e2e="'block-regimeCasamento-socio'"
        ></TrfSelect>
        <p class="error-message" v-if="markupErrorRegimeDoCasamento">
            Campo obrigatório!
        </p>
      </div>
    </div>
    </div>
  </template>
  <script>
  import { defineAsyncComponent } from 'vue';
import { camposEnderecoStore } from '../../../stateManagement/camposEndereco';
import { camposSocioStore } from '../../../stateManagement/camposSocio';
import { opcoesRegimeCasamento } from '../../../util/optionsEstaticos.utils';
import TrfSelect from '../../Select/index.vue'; // importado normalmente para evitar condição de corrida ao preencher pra edição
  export default {
    name: 'TrfBlocoSocioDadosComplementares',
    emits: ['update:form-data', 'set:validacao'],
    components: {
        TrfInput: defineAsyncComponent(() => import('../../Input/index.vue')),
        TrfSelect
    },
    props: {
        pSexo: {
            type: String,
            default: ''
        },
        pCor: {
            type: String,
            default: ''
        },
        pEscolaridade: {
            type: String,
            default: ''
        },
        pPaisDeNascimento: {
            type: String,
            default: ''
        },
        pNacionalidade: {
            type: String,
            default: ''
        },
        pNaturalidade: {
            type: String,
            default: ''
        },
        pMunicipioDeNascimento: {
            type: String,
            default: ''
        },
        pEstadoCivil: {
            type: String,
            default: ''
        },
        pRegimeDoCasamento: {
            type: String,
            default: ''
        },
        pPreview: {
            type: Boolean,
            default: true
        },
        pIsConferencia: {
            type: Boolean,
            default: false
        },
        pIsDirty: {
          type: Boolean,
          default: false
        },
        pSocioEmPreenchimento: {
            type: Object,
            default: null
        },
        required: {
          type: Boolean,
          default: false
        }
    },
    data() {
      return {
        data: {
          loading: false,
          listagemSexo: [],
          listagemCor: [],
          listagemEscolaridade: [],
          listagemPaises: [],
          listagemEstados: [],
          listagemEstadoCivil: [],
          listagemRegimeCasamento: opcoesRegimeCasamento
        },
        formData: {
            sexo: this.pSexo,
            cor: this.pCor,
            escolaridade: this.pEscolaridade,
            paisDeNascimento: this.pPaisDeNascimento,
            nacionalidade: this.pNacionalidade,
            naturalidade: this.pNaturalidade,
            municipioDeNascimento: this.pMunicipioDeNascimento,
            estadoCivil: this.pEstadoCivil,
            regimeDoCasamento: this.pRegimeDoCasamento
        },
        dirtyState: {
            sexo: this.pIsDirty,
            cor: this.pIsDirty,
            escolaridade: this.pIsDirty,
            paisDeNascimento: this.pIsDirty,
            nacionalidade: this.pIsDirty,
            naturalidade: this.pIsDirty,
            municipioDeNascimento: this.pIsDirty,
            estadoCivil: this.pIsDirty,
            regimeDoCasamento: this.pIsDirty
        }
      };
    },
    computed: {
        isDirty: {
            get() {
                return this.dirtyState.sexo && this.dirtyState.cor && this.dirtyState.escolaridade && this.dirtyState.paisDeNascimento && this.dirtyState.nacionalidade && this.dirtyState.naturalidade && this.dirtyState.municipioDeNascimento && this.dirtyState.estadoCivil && this.dirtyState.regimeDoCasamento;
            },
            set(valor) {
                for(let campo in this.dirtyState) {
                    this.dirtyState[campo] = valor
                }
            }
        },
        isSexoInvalido() {
            if (!this.required) return false;
            return this.dirtyState.sexo && !this.formData.sexo
        },
        markupErrorSexo() {
            return !this.pPreview && this.isSexoInvalido
        },
        isCorInvalido() {
            if (!this.required) return false;
            return this.dirtyState.cor && !this.formData.cor
        },
        markupErrorCor() {
            return !this.pPreview && this.isCorInvalido
        },
        isEscolaridadeInvalido() {
            if (!this.required) return false;
            return this.dirtyState.escolaridade && !this.formData.escolaridade
        },
        markupErrorEscolaridade() {
            return !this.pPreview && this.isEscolaridadeInvalido
        },
        isPaisDeNascimentoInvalido() {
            if (!this.required) return false;
            return this.dirtyState.paisDeNascimento && !this.formData.paisDeNascimento
        },
        markupErrorPaisDeNascimento() {
            return !this.pPreview && this.isPaisDeNascimentoInvalido
        },
        isNacionalidadeInvalido() {
            if (!this.required) return false;
            return this.dirtyState.nacionalidade && !this.formData.nacionalidade
        },
        markupErrorNacionalidade() {
            return !this.pPreview && this.isNacionalidadeInvalido
        },
        isNaturalidadeInvalido() {
            if (!this.required || this.formData.nacionalidade != 105) return false;
            return this.dirtyState.naturalidade && !this.formData.naturalidade
        },
        markupErrorNaturalidade() {
            return !this.pPreview && this.isNaturalidadeInvalido
        },
        isMunicipioDeNascimentoInvalido() {
            if (!this.required || this.formData.nacionalidade != 105) return false;
            return this.dirtyState.municipioDeNascimento && !this.formData.municipioDeNascimento
        },
        markupErrorMunicipioDeNascimento() {
            return !this.pPreview && this.isMunicipioDeNascimentoInvalido
        },
        isEstadoCivilInvalido() {
            if (!this.required) return false;
            return this.dirtyState.estadoCivil && !this.formData.estadoCivil
        },
        markupErrorEstadoCivil() {
            return !this.pPreview && this.isEstadoCivilInvalido
        },
        isRegimeDoCasamentoInvalido() {
            if (!this.required) return false;
            return this.dirtyState.regimeDoCasamento && !this.formData.regimeDoCasamento
        },
        markupErrorRegimeDoCasamento() {
            return !this.pPreview && this.isRegimeDoCasamentoInvalido
        },
        isInvalida() {
          const validaCamposExtras = this.formData.nacionalidade == 105? (this.isNaturalidadeInvalido || this.isMunicipioDeNascimentoInvalido) : false;
          return this.isSexoInvalido || this.isCorInvalido || this.isEscolaridadeInvalido || this.isPaisDeNascimentoInvalido || this.isNacionalidadeInvalido || validaCamposExtras || this.isEstadoCivilInvalido || this.isRegimeDoCasamentoInvalido;
        }
    },
    watch: {
        pIsDirty: {
            immediate: true,
            handler(novo) {
                this.isDirty = novo
            }
        },
        isInvalida: {
            immediate: true,
            handler(novo) {
                if(this.required) {
                    this.$emit('set:validacao', !novo);
                }
            }
        }
    },
    methods: {
        async iniciarCamposSelects() {
          if (this.pPreview && !this.pIsConferencia) return;
          this.data.loading = true;
          if((!camposEnderecoStore.estados && !camposEnderecoStore.isLoadingEstados) || (!camposEnderecoStore.paises && !camposEnderecoStore.isLoadingPaises) ) {
            await camposEnderecoStore.adquirirTodosOsCampos();
          }
          if (!camposSocioStore.tiposSexo || !camposSocioStore.tiposRaca || !camposSocioStore.tiposEscolaridade || !camposSocioStore.tiposEstadoCivil) {
            await camposSocioStore.adquirirTodosOsCampos();
          }
          this.data.listagemPaises = camposEnderecoStore.paises
          this.data.listagemEstados = camposEnderecoStore.estados
          this.data.listagemSexo = camposSocioStore.tiposSexo
          this.data.listagemCor = camposSocioStore.tiposRaca
          this.data.listagemEscolaridade = camposSocioStore.tiposEscolaridade
          this.data.listagemEstadoCivil = camposSocioStore.tiposEstadoCivil
          this.data.listagemRegimeCasamento = opcoesRegimeCasamento
          this.data.loading = false;
          await this.$nextTick();
          await this.preencherCamposEditavies();
          this.emitFormData(this.formData);
        },
        async preencherCamposEditavies() {
          if (!this.pSocioEmPreenchimento) return;
          // precisa definir o formData antes pois a seleção dos campos dispara o evento de atualização.
          this.formData.sexo = this.pSocioEmPreenchimento.socio.sexo? this.pSocioEmPreenchimento.socio.sexo : this.pSexo;
          this.formData.cor = this.pSocioEmPreenchimento.socio.cor? this.pSocioEmPreenchimento.socio.cor : this.pCor;
          this.formData.escolaridade = this.pSocioEmPreenchimento.socio.escolaridade? this.pSocioEmPreenchimento.socio.escolaridade : this.pEscolaridade;
          this.formData.paisDeNascimento = this.pSocioEmPreenchimento.socio.paisDeNascimento? this.pSocioEmPreenchimento.socio.paisDeNascimento : this.pPaisDeNascimento;
          this.formData.nacionalidade = this.pSocioEmPreenchimento.socio.nacionalidade? this.pSocioEmPreenchimento.socio.nacionalidade : this.pNacionalidade;
          this.formData.estadoCivil = this.pSocioEmPreenchimento.socio.estadoCivil? this.pSocioEmPreenchimento.socio.estadoCivil : this.pEstadoCivil;
          this.formData.regimeDoCasamento = this.pSocioEmPreenchimento.socio.regimeDoCasamento? this.pSocioEmPreenchimento.socio.regimeDoCasamento : this.pRegimeDoCasamento;

          if (this.formData.nacionalidade == 105) {
            await this.$nextTick();
            this.formData.naturalidade = this.pSocioEmPreenchimento.socio.naturalidade? this.pSocioEmPreenchimento.socio.naturalidade : this.pNaturalidade;
            this.formData.municipioDeNascimento = this.pSocioEmPreenchimento.socio.municipioDeNascimento? this.pSocioEmPreenchimento.socio.municipioDeNascimento : this.pMunicipioDeNascimento;
            this.$refs.BlockSocioNaturalidade.selecionar(this.formData.naturalidade)
          }
          this.$refs.BlockSocioSexo.selecionar(this.formData.sexo)
          this.$refs.BlockSocioCor.selecionar(this.formData.cor)
          this.$refs.BlockSocioEscolaridade.selecionar(this.formData.escolaridade)
          this.$refs.BlockSocioPaisDeNascimento.selecionar(this.formData.paisDeNascimento)
          this.$refs.BlockSocioNacionalidade.selecionar(this.formData.nacionalidade)
          this.$refs.BlockSocioEstadoCivil.selecionar(this.formData.estadoCivil)
          this.$refs.BlockSocioRegimeDoCasamento.selecionar(this.formData.regimeDoCasamento)
        },
        setSexo(sexo) {
            this.formData.sexo = sexo;
            this.emitFormData(this.formData)
            this.dirtyState.sexo = true;
        },
        setCor(cor) {
            this.formData.cor = cor;
            this.emitFormData(this.formData)
            this.dirtyState.cor = true;
        },
        setEscolaridade(escolaridade) {
            this.formData.escolaridade = escolaridade;
            this.emitFormData(this.formData)
            this.dirtyState.escolaridade = true;
        },
        setPaisDeNascimento(paisDeNascimento) {
            this.formData.paisDeNascimento = paisDeNascimento;
            this.emitFormData(this.formData)
            this.dirtyState.paisDeNascimento = true;
        },
        setNacionalidade(nacionalidade) {
            this.formData.nacionalidade = nacionalidade;
            this.emitFormData(this.formData)
            this.dirtyState.nacionalidade = true;
        },
        setNaturalidade(naturalidade) {
            this.formData.naturalidade = naturalidade;
            this.emitFormData(this.formData)
            this.dirtyState.naturalidade = true;
        },
        setEstadoCivil(estadoCivil) {
            this.formData.estadoCivil = estadoCivil;
            this.emitFormData(this.formData)
            this.dirtyState.estadoCivil = true;
        },
        setRegimeDoCasamento(regimeDoCasamento) {
            this.formData.regimeDoCasamento = regimeDoCasamento;
            this.emitFormData(this.formData)
            this.dirtyState.regimeDoCasamento = true;
        },
        setMunicipioDeNascimento(municipioDeNascimento) {
            this.formData.municipioDeNascimento = municipioDeNascimento;
            this.emitFormData(this.formData)
            this.dirtyState.municipioDeNascimento = true;
        },
        emitFormData(formData = this.formData) {
            this.$emit('update:form-data', formData)
        },
    },
    mounted() {
      this.iniciarCamposSelects();
    }
  };
  </script>
  